
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91sectionUrl_93ZB8pWh374gMeta } from "/vercel/path1/pages/[sectionUrl].vue?macro=true";
import { default as _91articleId_93P1Z4QqGMstMeta } from "/vercel/path1/pages/article-detail/[articleId].vue?macro=true";
import { default as _91articleUrl_93Ov9Y6nVCr6Meta } from "/vercel/path1/pages/articles/[articleUrl].vue?macro=true";
import { default as _91authorUrl_93PCrZiMdLPnMeta } from "/vercel/path1/pages/authors/[authorUrl].vue?macro=true";
import { default as indexvKXKdzYNuzMeta } from "/vercel/path1/pages/debug/index.vue?macro=true";
import { default as _91articleUrl_93OUKnTHgAv0Meta } from "/vercel/path1/pages/galleries/[articleUrl].vue?macro=true";
import { default as indexzhmolsBfabMeta } from "/vercel/path1/pages/index.vue?macro=true";
import { default as indexfnAJp32TvaMeta } from "/vercel/path1/pages/login/index.vue?macro=true";
import { default as refreshQyOwajkTDkMeta } from "/vercel/path1/pages/login/refresh.vue?macro=true";
import { default as indexGNpUnVBZxbMeta } from "/vercel/path1/pages/newsletter/confirmation/index.vue?macro=true";
import { default as indexKnqBI5in3rMeta } from "/vercel/path1/pages/newsletter/index.vue?macro=true";
import { default as _91authorId_93xtttTI3Yz0Meta } from "/vercel/path1/pages/newsroom/[authorId].vue?macro=true";
import { default as indexBHgRUXHlVVMeta } from "/vercel/path1/pages/newsroom/index.vue?macro=true";
import { default as index7qdmDkLpnSMeta } from "/vercel/path1/pages/profile/index.vue?macro=true";
import { default as indexTj4RXnma2JMeta } from "/vercel/path1/pages/search/index.vue?macro=true";
export default [
  {
    name: "sectionUrl___cs",
    path: "/:sectionUrl()",
    meta: _91sectionUrl_93ZB8pWh374gMeta || {},
    component: () => import("/vercel/path1/pages/[sectionUrl].vue")
  },
  {
    name: "article-detail-articleId___cs",
    path: "/article-detail/:articleId()",
    meta: _91articleId_93P1Z4QqGMstMeta || {},
    component: () => import("/vercel/path1/pages/article-detail/[articleId].vue")
  },
  {
    name: "articles-articleUrl___cs",
    path: "/clanek/:articleUrl()",
    meta: _91articleUrl_93Ov9Y6nVCr6Meta || {},
    component: () => import("/vercel/path1/pages/articles/[articleUrl].vue")
  },
  {
    name: "authors-authorUrl___cs",
    path: "/autor/:authorUrl()",
    meta: _91authorUrl_93PCrZiMdLPnMeta || {},
    component: () => import("/vercel/path1/pages/authors/[authorUrl].vue")
  },
  {
    name: "debug___cs",
    path: "/debug",
    component: () => import("/vercel/path1/pages/debug/index.vue")
  },
  {
    name: "galleries-articleUrl___cs",
    path: "/galerie/:articleUrl()",
    meta: _91articleUrl_93OUKnTHgAv0Meta || {},
    component: () => import("/vercel/path1/pages/galleries/[articleUrl].vue")
  },
  {
    name: "homepage___cs",
    path: "/",
    meta: indexzhmolsBfabMeta || {},
    component: () => import("/vercel/path1/pages/index.vue")
  },
  {
    name: "login___cs",
    path: "/login",
    component: () => import("/vercel/path1/pages/login/index.vue")
  },
  {
    name: "login-refresh___cs",
    path: "/login/refresh",
    component: () => import("/vercel/path1/pages/login/refresh.vue")
  },
  {
    name: "newsletter-confirmation___cs",
    path: "/newsletter/confirmation",
    meta: indexGNpUnVBZxbMeta || {},
    component: () => import("/vercel/path1/pages/newsletter/confirmation/index.vue")
  },
  {
    name: "newsletter___cs",
    path: "/newsletter",
    meta: indexKnqBI5in3rMeta || {},
    component: () => import("/vercel/path1/pages/newsletter/index.vue")
  },
  {
    name: "newsroom-authorId___cs",
    path: "/redakce/:authorId()",
    meta: _91authorId_93xtttTI3Yz0Meta || {},
    component: () => import("/vercel/path1/pages/newsroom/[authorId].vue")
  },
  {
    name: "newsroom___cs",
    path: "/redakce",
    meta: indexBHgRUXHlVVMeta || {},
    component: () => import("/vercel/path1/pages/newsroom/index.vue")
  },
  {
    name: "profile___cs",
    path: "/profil",
    meta: index7qdmDkLpnSMeta || {},
    component: () => import("/vercel/path1/pages/profile/index.vue")
  },
  {
    name: "search___cs",
    path: "/hledej",
    meta: indexTj4RXnma2JMeta || {},
    component: () => import("/vercel/path1/pages/search/index.vue")
  }
]